import apiClient from "./apiClient";

export const GetResults = async (v) => {
  return apiClient
    .post("exam/get", v)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      return error;
    });
};